import React, { useCallback, useContext, useEffect, useState } from "react";

/// React router dom
import { Routes, Route, Outlet, BrowserRouter, Navigate, useNavigate } from "react-router-dom";

/// Css
import "./index.css";
import "./chart.css";
import "./step.css";

/// Layout
import Nav from "./layouts/nav";


import ScrollToTop from "./layouts/ScrollToTop";
/// Dashboard
import Home from "./components/Dashboard/Home";

import SortingTable from "./components/table/SortingTable/SortingTable";
import FilteringTable from "./components/table/FilteringTable/FilteringTable";


import LockScreen from "./pages/LockScreen";
import Error400 from "./pages/Error400";
import Error403 from "./pages/Error403";
import Error404 from "./pages/Error404";
import Error500 from "./pages/Error500";
import Error503 from "./pages/Error503";
import { ThemeContext } from "../context/ThemeContext";
import AddInvoice from "./components/Dashboard/AddInvoice";
import SingleEntry from "./components/Dashboard/singleEntry/singleEntry";
import BulkUpload from "./components/Dashboard/bulkUpload/bulkUpload";
import VerificationScreen from "./components/Dashboard/verificationScreen/verificationScreen";
import InvoiceList from "./components/Dashboard/Invoices/invoiceList";
import DemoFile from "./components/Dashboard/demoFile/demoFile";
import VerificationEditScreen from "./components/Dashboard/Invoices/verficationEditScreen";
import AddProperty from "./pages/propertyPages/propertyPages";
import { authenticate, signout } from "../feature/authSlice";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import { useDispatch, useSelector } from "react-redux";
import RegisterProperty from "./pages/propertyPages/registerProperty";


import UplaodedInvoices from "../../src/jsx/pages/uploadedInvoices/uplaodedInvoices";
import PropertyListPage from "./pages/propertyList/propertyListPage";
import PdfView from "./pages/pdfView/pdfView";
import BulkUploadProperty from "./pages/propertyPages/bulkUploadProperty";
import ForgotPasswordAuth from "./pages/auth/forgotPassword";
import ResetPassword from "./pages/auth/resetPassword";
import GetInvoiceByEmail from "./pages/auth/getInvoiceByEmail";
import ViewVendors from "./pages/vendors/assignedVendors/assignedVendors";
import ChangePassword from "./pages/auth/changePassword";
import VendorsList from "./pages/vendors/addAndListOfAllVendors/vendorList";
import AssignUsers from "./pages/users/AssignUsers";
import ManagePermissions from "./pages/auth/ManagePermissions";
import { setPermissions } from "../feature/permissions";
import GenerateBankFile from "./pages/vendors/assignedVendors/GenerateBankFile";
import ViewTelephoneInvoiceScreen from "./components/Dashboard/Invoices/viewTelephoneInvoiceScreen";
import { removeDataForInvoiceByEmail } from "../feature/getInvoiceByEmailSlice";
import RegisterUser from "./pages/RegisterUser";
import SetPasswordForNewUser from "./pages/auth/SetPasswordForNewUser";
import UpdatePayment from "./pages/UpdatePayment";
import NotificationListener from "../service/NotificationListener";
import { ToastContainer } from "react-toastify";

const Markup = () => {
  const { authorized, permissionArr } = useSelector(state => state.auth)
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path='page-lock-screen' element={<LockScreen />} />
          <Route path='page-error-400' element={<Error400 />} />
          <Route path='page-error-403' element={<Error403 />} />
          <Route path='page-error-404' element={<Error404 />} />
          <Route path='page-error-500' element={<Error500 />} />
          <Route path='page-error-503' element={<Error503 />} />
          {authorized ? (
            <Route element={<MainLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="dashboard" element={<Home />} />
              <Route path="addInvoice" element={<AddInvoice />} />
              <Route path="singleEntry" element={<SingleEntry />} />
              <Route path="bulkUpload" element={<BulkUpload />} />
              <Route path="uploadProperty" element={<BulkUploadProperty />} />
              <Route path="invoiceVerification" element={<UplaodedInvoices />} />
              <Route path="verificationScreen" element={<VerificationScreen />} />
              <Route path="invoiceList" element={<InvoiceList />} />
              <Route path="demoFile" element={<DemoFile />} />
              <Route path="sortingTable" element={<SortingTable />} />
              <Route path="filteringTable" element={<FilteringTable />} />
              <Route path="verificationEditScreen" element={<VerificationEditScreen />} />
              <Route path="addProperty" element={<AddProperty />} />
              {/* <Route path="registerProperty" element={<RegisterProperty />} /> */}
              <Route path="propertyList" element={<PropertyListPage />} />
              <Route path="pdfView" element={<PdfView />} />
              <Route path="regUser" element={<RegisterUser />} />
              <Route path="updatePayment" element={<UpdatePayment />} />
              <Route path="managePermissions" element={<ManagePermissions />} />
              <Route path="viewVendors" element={<ViewVendors />} />
              <Route path="vendorList" element={<VendorsList />} />
              <Route path="assignUsers" element={<AssignUsers />} />
              <Route path="generateBankFile" element={<GenerateBankFile />} />
              <Route path="viewTelephoneInvoiceScreen" element={<ViewTelephoneInvoiceScreen />} />
              <Route path="*" element={<Home />} />
              <Route path="InvoiceApproval/:token" element={<GetInvoiceByEmail />} />
            </Route>
          ) : (
            <>
              <Route path="/" element={<Navigate to="/login" />} />
              <Route path="login" element={<Login />} />
              <Route path="forgotPassword" element={<ForgotPasswordAuth />} />
              <Route path="Account/SetPassword" element={<SetPasswordForNewUser />} />
              <Route path="verifyAndReset" element={<ResetPassword />} />
              <Route path="changePassword" element={<ChangePassword />} />
              <Route path="*" element={<Navigate to="/login" />} />
              <Route path="InvoiceApproval/:token" element={<GetInvoiceByEmail />} />
            </>
          )}
        </Routes>
        <ScrollToTop />
      </BrowserRouter>
    </>
  );
};

function MainLayout() {
  const { menuToggle } = useContext(ThemeContext);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleLogout = () => {
    // console.log("User is idle for too long. Logging out...");
    localStorage.removeItem("Ok");
    dispatch(signout());
    dispatch(setPermissions(null))
    dispatch(removeDataForInvoiceByEmail());
    localStorage.clear();
    navigate('/login', { 
      replace: true,
      state: { clearHistory: true }
    });
  };


  useEffect(() => {
    let idleTime = 0;
    const timeoutDuration = 900000;

    const events = ["load", "mousemove", "mousedown", "click", "keydown", "scroll", "keypress"];
    const resetIdleTime = () => {
      idleTime = 0;
      // console.log("Activity detected. Resetting idle time.");
    };

    const checkIdleTimeout = () => {
      idleTime += 1000;
      // console.log(`Idle time: ${idleTime / 1000} seconds`);
      if (idleTime >= timeoutDuration) {
        handleLogout();
      }
    };

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        // console.log("Escape key pressed");
        resetIdleTime()
      }
    };

    events.forEach((event) => {
      window.addEventListener(event, resetIdleTime);
    });

    window.addEventListener("keydown", handleKeyDown);

    const timer = setInterval(checkIdleTimeout, 1000);

    return () => {
      events.forEach((event) => {
        window.removeEventListener(event, resetIdleTime);
      });
      window.removeEventListener("keydown", handleKeyDown);
      clearInterval(timer);
    };
  }, [dispatch, navigate]);



  return (
    <div id="main-wrapper" className={`show ${menuToggle ? "menu-toggle" : ""}`}>
      <Nav />
       <ToastContainer />
      <NotificationListener/>
      <div className="content-body" style={{ minHeight: window.screen.height - 45 }}>
        <div className="container-fluid">
          <Outlet />
        </div>
      </div>
      {/* <Footer /> */}
    </div>
  )

};

export default Markup;